 (function () {
  "use strict";

  const TZ = "America/Chicago";
  const CUTOFF_HOUR = 19;
  const CUTOFF_MIN = 0;

  function getNowInTZ() {
    return new Date(
      new Date().toLocaleString("en-US", { timeZone: TZ })
    );
  }

  function getNextDeliveryDate() {
    const now = getNowInTZ();
    const day = now.getDay();
    const hour = now.getHours();
    const minute = now.getMinutes();

    const afterCutoff =
      hour > CUTOFF_HOUR ||
      (hour === CUTOFF_HOUR && minute >= CUTOFF_MIN);

    function nextWeekday(targetDay) {
      const d = new Date(now);
      const delta = (targetDay - day + 7) % 7;
      d.setDate(now.getDate() + delta);
      d.setHours(0, 0, 0, 0);
      return d;
    }

    let cutoffDay;

    if (day === 0 && !afterCutoff) {
      cutoffDay = 0;
    } else if (day < 3 || (day === 3 && !afterCutoff)) {
      cutoffDay = 3;
    } else {
      cutoffDay = 0;
    }

    return cutoffDay === 0
      ? nextWeekday(1)
      : nextWeekday(4);
  }

  function getCutoffLabel() {
  const deliveryDate = getNextDeliveryDate();

  return deliveryDate.getDay() === 1
    ? "Sunday at 7 PM"
    : "Wednesday at 7 PM";
}

  function formatDate(d) {
    return d.toLocaleDateString("en-US", {
      weekday: "long",
      month: "short",
      day: "numeric",
      year: "numeric"
    });
  }

  window.PFKDelivery = {
    getNextDeliveryDate,
    getCutoffLabel,
    formatDate
  };

})();